import { render, staticRenderFns } from "./CardEtapa.vue?vue&type=template&id=14c687fa&scoped=true"
import script from "./CardEtapa.vue?vue&type=script&lang=js"
export * from "./CardEtapa.vue?vue&type=script&lang=js"
import style0 from "./CardEtapa.vue?vue&type=style&index=0&id=14c687fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c687fa",
  null
  
)

export default component.exports